import type { CSSProperties, ReactNode } from 'react';

import classNames from 'classnames';

import styles from './Tooltip.module.scss';

export const Tooltip = (props: {
  children: ReactNode;
  tooltipPositionStyle: CSSProperties;
  arrowClassName?: string;
  tooltipClassName?: string;
  showArrow?: boolean;
  setTooltipRef: (el: HTMLElement | null) => void;
}) => {
  return (
    <div
      ref={props.setTooltipRef}
      className={classNames(styles.tooltip, props.tooltipClassName)}
      style={props.tooltipPositionStyle}
    >
      {props.children}
      {props.showArrow && <div className={classNames('arrow-tooltip', props.arrowClassName)} />}
    </div>
  );
};
